import { MOBILE_SCREEN_WIDTH } from "./../constants";

export const isMobileDevice = (screen) => {
  return screen.innerWidth <= MOBILE_SCREEN_WIDTH;
};
